// PenaltyInput.tsx
import { useState } from "react";
import { Input } from "@/components/ui/input/input";
import { Button } from "@/components/ui/button/button";
import { XCircleIcon } from "lucide-react";

interface PenaltyInputProps {
  value: string[];
  onChange: (value: string[]) => void;
}

const PenaltyInput: React.FC<PenaltyInputProps> = ({ value, onChange }) => {
  const [inputValue, setInputValue] = useState("");

  const handleAddPenalty = () => {
    const trimmed = inputValue.trim();
    if (trimmed) {
      onChange([...value, trimmed]);
      setInputValue("");
    }
  };

  const handleRemovePenalty = (index: number) => {
    const updated = value.filter((_, i) => i !== index);
    onChange(updated);
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2">
        <Input
          placeholder="Enter penalty..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAddPenalty();
            }
          }}
        />
        <Button variant="outline" type="button" onClick={handleAddPenalty}>
          Add
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {value.map((penalty, index) => (
          <div
            key={index}
            className="flex items-center gap-1 bg-foreground/10 px-2 py-1 rounded"
          >
            <span className="text-sm line-clamp-1">{penalty}</span>
            <button type="button" onClick={() => handleRemovePenalty(index)}>
              <XCircleIcon className="h-4 w-4 text-red-500" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PenaltyInput;
